/*菜单 */
import { $http, buildHeaders } from "./index";

//获取列表
export const menu_tree = () => {
  return $http.get("/admin/Menu/index", {
    params: { tree: 1, status: 1 },
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};
